import { BasicTreeModule } from '@caslink/common-client/ng-app/basic-tree/basic-tree.module';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TreeViewCellComponent } from './tree-view-cell.component';

@NgModule({
    imports: [
        CommonModule,
        BasicTreeModule,
    ],
    declarations: [
        TreeViewCellComponent,
    ],
    exports: [
        TreeViewCellComponent,
    ],
})

export class TreeViewCellModule {}
